import { render, staticRenderFns } from "./buyDetail.vue?vue&type=template&id=6e8e2346&scoped=true"
import script from "./buyDetail.vue?vue&type=script&lang=js"
export * from "./buyDetail.vue?vue&type=script&lang=js"
import style0 from "./buyDetail.vue?vue&type=style&index=0&id=6e8e2346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8e2346",
  null
  
)

export default component.exports